module.exports = __webpack_public_path__ + "static/media/serviceMainImageDesktop@2x.5bec6df7.png";